import React from 'react';

export default function TrustBar(): React.JSX.Element {
  return (
    <div className='d-flex flex-column flex-md-row align-items-center justify-content-between'>
      <div className='text-muted small'>
        <strong>Trusted by career builders</strong> — used by professionals
        across tech, finance, and more.
      </div>
      <div className='d-flex gap-2 mt-2 mt-md-0'>
        <div className='px-3 py-2 bg-white border rounded text-muted small'>
          Secure & trusted
        </div>
        <div className='px-3 py-2 bg-white border rounded text-muted small'>
          Cancel anytime
        </div>
        <div className='px-3 py-2 bg-white border rounded text-muted small'>
          No hidden fees
        </div>
      </div>
    </div>
  );
}
